import { action, observable } from 'mobx';
import {storageGetItem, storageSetItem} from "Utils/utils";

class NetDriverStore {
  constructor() {

    // this.onBeforeInstallPromptEvent = this.onBeforeInstallPromptEvent.bind(this);
    // this.onAppInstalled = this.onAppInstalled.bind(this);
    // this.onThrottle_NotifyOffline = this.onThrottle_NotifyOfflineWrapper();
  }

  @observable drivers = [];
  @observable ReloadFirstPageMenu = null; // 首页选择打开的的菜单.
  @observable driversUpdateFlag = {}

  @action SetDriverReloadFlag(driverName, updateFlag){
    this.driversUpdateFlag[driverName] = updateFlag
  }
  @action GetDriverReloadFlag(driverName){
    let reloadFlag = this.driversUpdateFlag[driverName]
    return reloadFlag == undefined ? false : reloadFlag
  }

  @action GetDriverUserInfo(driverName, userId){
    let driveTokenInfo = JSON.parse(storageGetItem(localStorage, 'netdriverTokenInfo'));
    if(driveTokenInfo && driveTokenInfo[driverName] != undefined){
      let ret = driveTokenInfo[driverName].find((item)=>{
        return item.userId == userId;
      });
      return ret;
    }

  }
  @action SetDriverUserInfo(driverName, userInfo) {
    let driveTokenInfo = JSON.parse(storageGetItem(localStorage, 'netdriverTokenInfo'))
    if (!driveTokenInfo) {
      let allnetDriveTokenInfo = {
        [driverName]: [],
      };
      allnetDriveTokenInfo = {
        ...allnetDriveTokenInfo,
        [driverName]: [
          userInfo,
        ]
      };
      storageSetItem(localStorage, 'netdriverTokenInfo', JSON.stringify(allnetDriveTokenInfo));
      driveTokenInfo = JSON.parse(storageGetItem(localStorage, 'netdriverTokenInfo'));
    }

    if (driveTokenInfo[driverName] == undefined) {
      driveTokenInfo[driverName] = [];
    }
    ;
    if (!driveTokenInfo[driverName].length) {
      driveTokenInfo[driverName].push(
          userInfo
      );
      storageSetItem(localStorage, 'netdriverTokenInfo', JSON.stringify(driveTokenInfo));
      return
    }

    storageSetItem(localStorage, 'netdriverTokenInfo', JSON.stringify(driveTokenInfo))

    const isRecorded = driveTokenInfo[driverName].some((item) => {
      if (item.userId === userInfo.userId) {
        return true;
      }
    });

    if (!isRecorded) {
      driveTokenInfo[driverName].push(
          userInfo
      );
    }
    storageSetItem(localStorage, 'netdriverTokenInfo', JSON.stringify(driveTokenInfo));

  }
  @action findDriverbyDriverName(driverName){
    return this.drivers.find((item) => item.driverName == driverName);


  }
  @action findDriverIdByDriverName(driverName){
    let res = this.drivers.find((item) => item.title == driverName);
    return res == undefined ? "": res.driverId;
  }

  @action findDriverIcon(driverName) {
    let res = this.drivers.find((item) => item.title == driverName);
    return res == undefined ? '' : res.icon.selected;
  }
  @action findDriverTitle(title) {
    let res = this.drivers.find((item) => item.driverId == title);
    return res == undefined ? title : res.title
  }
  @action findDriverTitleByDriverId(driverId){
    let ret = this.drivers.find((item) => item.driverId == driverId);
    if(ret){
      return ret.title;
    }
    return ""
  }
  @action setReloadFirstPageMenu(method){
    return this.ReloadFirstPageMenu = method;
  }
  // driverItem {
  //     userInfo:{},
  //     isSignIn: false,
  // }

  //
  //
  @action AddNetDrivers(item) {
    this.drivers.push(item);
  }

  @action netDriverSetUserInfo(driverId, userInfo) {
    this.drivers.some((item) => {
      if (item.driverId === driverId) {
        item['userInfo'] = userInfo;
      }
    });
  }

  @action setNetDriverIsSignIn(driverId,isSignIn){

    let driverItem = this.drivers.filter((item)=>{
      if (item.driverId == driverId){
        return item
      }
    })

    driverItem.isSignIn = isSignIn;
    // if(driverItem!=)
  }
}

export default NetDriverStore;
